import React, { createContext, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { extractPatientIdFromUrl } from '../utils/helpers';
import { obtenerComentarios, obtenerDocumentaciones } from '../services/patient';
import { message } from 'antd';
import { deleteRequest } from '../services/base';
import {procedenciasCode} from "../utils/enums/statusCodes";

const DocumentacionContext = createContext();

const DocumentacionContextProvider = ({ children }) => {
  
const [documentacionesAfiliados, setDocumentacionesAfiliados] = useState([]);
const [comentariosAfiliados, setComentariosAfiliados] = useState([]);

useEffect(() => {
    const obtenerDocumentacionesAfiliado = async () => {
      try {
        const documentaciones = await obtenerDocumentaciones(extractPatientIdFromUrl());
        setDocumentacionesAfiliados(documentaciones);
      } catch (error) {
        console.error("Error obteniendo documentaciones:", error);
      }
    };
  
    obtenerDocumentacionesAfiliado();
  }, []);

  useEffect(() => {
    const obtenerComentariosAfiliado = async () => {
      try {
        const comentarios = await obtenerComentarios(extractPatientIdFromUrl());
        setComentariosAfiliados(comentarios);
      } catch (error) {
        console.error("Error obteniendo comentarios:", error);
      }
    };
  
    obtenerComentariosAfiliado();
  }, []);

  const actualizarComentarios = async () => {
    try {
        const comentarios = await obtenerComentarios(extractPatientIdFromUrl());
        setComentariosAfiliados(comentarios);
      } catch (error) {
        console.error("Error obteniendo comentarios:", error);
      }
  };

  const actualizarDocumentaciones = async () => {
    try {
        const documentaciones = await obtenerDocumentaciones(extractPatientIdFromUrl());
        setDocumentacionesAfiliados(documentaciones);
      } catch (error) {
        console.error("Error obteniendo documentaciones:", error);
      }
  };

  const eliminarComentario = async (comentario) => {
    try {
      const formDataToSend = {
        id: comentario.id,
        procedencia: procedenciasCode.General.value
      };
      await deleteRequest('/Documentacion/comentario',JSON.stringify(formDataToSend));

    } catch (error) {
      console.error("Error eliminando comentario:", error);
      message.error("Error eliminando comentario. Por favor, inténtelo de nuevo más tarde.");
    }
  }

  const eliminarArchivo = async (documentacion) => {
    try {
      const formDataToSend = {
        id: documentacion.id,
        procedencia: procedenciasCode.General.value
      };
      await deleteRequest('/Documentacion/archivo',JSON.stringify(formDataToSend));

    } catch (error) {
      console.error("Error eliminando archivo:", error);
      message.error("Error eliminando archivo. Por favor, inténtelo de nuevo más tarde.");
    }
  };

  const contextValue = {
    documentacionesAfiliados,
    comentariosAfiliados,
    actualizarComentarios,
    actualizarDocumentaciones,
    eliminarComentario,
    eliminarArchivo

  };
  return (
    <DocumentacionContext.Provider value={contextValue}>
      {children}
    </DocumentacionContext.Provider>
  );
};



DocumentacionContextProvider.propTypes = {
  children: PropTypes.node
};

export { DocumentacionContext,DocumentacionContextProvider };
